import {useEffect, useState} from "react";
import '../Styles/CreateIndividualReview.scss'
import { Link } from "react-router-dom";
import {Helmet} from "react-helmet";
import DateHelpers from '../Helper/DateHelpers.js';
import React from "react";



function CreateIndividualReview()
{
   

   const [existingInformation, setExistingInformation] = useState({
      firstName: '',
      lastName: '',
      title: '',
      gender: '',
      strAddress: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
      buddyName: '',
      buddyBirthDate: '',
      ecName: '',
      ecRelationship: '',
      ecPhone: '',
      groupCode: '',
      birthDate: '',
      guestPrefMail: 'off',
      insuranceCompany: '',
      insuranceId: '',
      groupPolicyNumber: '',
      policyHolderName: '',
      policyHolderBirthdate: '',
      isInsured: '',
      hasDiabetes: true,
      hasHeartCondition: 'off',
      hasEpilepsy: 'off',
      hasEnvironmentAllergies: 'off',
      hasHeatExhaustion: 'off',
      hasThyroidProblem: 'off',
      hasLupus: 'off',
      hasHighBloodPressure: 'off',
      hasAsthma: 'off',
      drugAllergies: '',
      emergencyAction1: '',
      foodAllergies: '',
      emergencyAction2: '',
      allergicReactions: '',
      otherAllergies: '',
      emergencyAction3: '',
      medicationName: '',
      medicationDose: '',
      tetanusShotDate: ''
   });

   const getUpdateInformation = async () => {
      try {

         const response2 = await fetch('/api/get-user', {
            method: 'GET',
            headers: { "Content-Type": "application/json" }
         })

         if (response2.status === 400 || response2.status === 500) {
            throw new Error("Failed User Retrieval");
         }

         const account = await response2.json();
  
         
         const response = await fetch('/getindividualinformation', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(
               {
                  email: account.user.email
               }
            )
         })
   
         // This will be updated with UseEffect                       // 
         const individualJSON = await response.json();
         const individualData = individualJSON.data[0]; 
         console.log("individualData",individualData)
         // Here is the info that is returning!

         setExistingInformation({...existingInformation, 
            firstName: individualData.first_name, 
            lastName: individualData.last_name, 
            gender: individualData.gender,
            strAddress: individualData.address1,
            city: individualData.city,
            state: individualData.state,
            zip: individualData.zip_code,
            phone: individualData.phone_number,
            email: individualData.email_address, 
            ecName: individualData.emergency_contact_name,
            ecRelationship: individualData.emergency_contact_relationship,
            ecPhone: individualData.emergency_contact_number,
            birthDate: individualData.birth_date,
            policyHolderBirthdate: individualData.policy_holder_birthdate, 
            tetanusShotDate: individualData.last_tetanus_shot_date,
            insuranceCompany: individualData.insurance_company,
            insuranceId: individualData.insurance_id_number,
            groupPolicyNumber: individualData.insurance_group_number,
            policyHolderName: individualData.policy_holder_name,
            isInsured: true,
            hasDiabetes: individualData.has_diabetes_or_hypoglycemia,
            hasHeartCondition: individualData.has_heart_condition,
            hasEpilepsy: individualData.has_epilepsy,
            hasEnvironmentAllergies: individualData.has_env_allergies,
            hasHeatExhaustion: individualData.has_problems_with_heat,
            hasThyroidProblem: individualData.has_thyroid_problems,
            hasLupus: individualData.has_lupus,
            hasHighBloodPressure: individualData.has_high_blood_pressure,
            hasAsthma: individualData.has_asthma
            }) 
         
         }

      catch (error) {
         console.error(error.message); 
         }
   };

   useEffect (() => { 
      getUpdateInformation();
     }, []);

   return(
      <div className="createIndividualReviewContent">
      <Helmet>
         <title>Review Individual Account - Camp Connect</title>
      </Helmet>
         <div className="createIndividualReviewContainer">
            <table className="createIndividualReviewTable">
               <tr>
                  <h1>Review Account Information*</h1>
               </tr>
               <tr>
                  <th>First Name</th>
                  <td>{existingInformation.firstName}</td>
               </tr>
               <tr>
                  <th>Last Name</th>
                  <td>{existingInformation.lastName}</td>
               </tr>
               <tr>
                  <th>Date of Birth</th>
                  <td>{DateHelpers.getDisplayDate(existingInformation.birthDate)}</td>
               </tr>
               <tr>
                  <th>Email Address</th>
                  <td>{existingInformation.email}</td>
               </tr>
               <tr>
                  <th>Phone Number</th>
                  <td>{existingInformation.phone}</td>
               </tr>
               <tr>
                  <th>City</th>
                  <td>{existingInformation.city}</td>
               </tr>
               <tr>
                  <th>State</th>
                  <td>{existingInformation.state}</td>
               </tr>
               <tr>
                  <th>Zip Code</th>
                  <td>{existingInformation.zip}</td>
               </tr>
               <tr>
                  <th>Emergency Contact Name</th>
                  <td>{existingInformation.ecName}</td>
               </tr>
               <tr>
                  <th>Emergency Contact Relationship</th>
                  <td>{existingInformation.ecRelationship}</td>
               </tr>
               <tr>
                  <th>Emergency Contact Phone</th>
                  <td>{existingInformation.ecPhone}</td>
               </tr>
               <tr>
                  <th>Has Diabetes/ Hypoglycemia</th>
                  <td>{existingInformation.hasDiabetes?"Yes":"No"}</td>
               </tr>
               <tr>
                  <th>Has Epilepsy</th>
                  <td>{existingInformation.hasEpilepsy?"Yes":"No"}</td>
               </tr>
               <tr>
                  <th>Has Enviromental Allergies</th>
                  <td>{existingInformation.hasEnvironmentAllergies?"Yes":"No"}</td>
               </tr>
               <tr>
                  <th>Has Heat Exhaustion/Problems</th>
                  <td>{existingInformation.hasHeatExhaustion?"Yes":"No"}</td>
               </tr>
               <tr>
                  <th>Has Thyroid Problems</th>
                  <td>{existingInformation.hasThyroidProblem?"Yes":"No"}</td>
               </tr>
               <tr>
                  <th>Has Lupus</th>
                  <td>{existingInformation.hasLupus?"Yes":"No"}</td>
               </tr>
               <tr>
                  <th>Has High Blood Pressure</th>
                  <td>{existingInformation.hasHighBloodPressure ?"Yes":"No"}</td>
               </tr>
               <tr>
                  <th>Has Asthma</th>
                  <td>{existingInformation.hasAsthma?"Yes":"No"}</td>
               </tr>
            </table>
            <div className="createIndividualReviewPageHr">
               <hr></hr>
            </div>
            <div className="createIndividualReviewbuttonbox">
               <Link  to={'/individualaccount'}>
                  <button>
                       View My Account
                  </button>
               </Link>
            </div>
            <div className="fakeDataDisclaimer">
            * Any data entered in text boxes will be replaced with fake data
            </div>
         </div>
      </div>
   )
}

export default CreateIndividualReview; 
